import PropTypes from 'prop-types';

const displayName = 'Banner';
const propTypes = {
  imgSource: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]).isRequired,
};
const defaultProps = {
  imgSource: [],
};

export default { propTypes, defaultProps, displayName };
